import React from 'react'
import BackdropMaker from '../components/backdrop-maker'
import Header from '../components/header/header'
import Page from './page'

const BackdropMakerPage = () => {
    return (
        <Page>
            <Header />
            <BackdropMaker />
        </Page>
    )
}

export default BackdropMakerPage
